export enum PayerRole {
  User = 'USER',
  Customer = 'CUSTOMER',
}
